'use client'

import { AppLink } from '@/shared/lib/router'

import { inputClassName, buttonClassName } from '../../constants/styles'
import { ResetPasswordButton } from '../ResetPassword/Button'
import { ResetPasswordFields } from '../ResetPassword/Fields'
import { ResetPasswordForm } from '../ResetPassword/Form'

import { Button } from '@/shared/ui/Button'
import { Card, CardHeader, CardTitle, CardBody } from '@/shared/ui/Card'

export function ResetPasswordPage() {
  return (
    <Card className="max-w-md">
      <CardHeader>
        <CardTitle>Redefinir Senha</CardTitle>
      </CardHeader>
      <CardBody className="text-dark">
        <ResetPasswordForm className="gap-4">
          <ResetPasswordFields inputClassName={inputClassName} />
          <ResetPasswordButton className={buttonClassName}>
            Redefinir Senha
          </ResetPasswordButton>
          <Button variant="secondary" asChild>
            <AppLink href="/sign-in">Cancelar</AppLink>
          </Button>
        </ResetPasswordForm>
      </CardBody>
    </Card>
  )
}
